
export default {
  name: 'App',//若使用这种name与路由名称要保持一致
  data() {
    return {
      data: '',
      beforeUnload: '',
      Handler: ''
    }
  },
  setup() {

  },
  //vue2中的生命周期也可使用
  mounted() {
    document.body.style.setProperty('--el-color-primary', '#409EFF');
    document.body.style.setProperty('--el-font-size-large', '16px');
    document.body.style.setProperty('--el-menu-active-color', '#409EFF');
    // document.body.style.setProperty('--el-color-primary-light-3', 'rgb(64, 158, 255 / 90%)');
    document.body.style.setProperty('--el-color-primary-dark-2', '#409EFF');
    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
    window.addEventListener('unload', e => this.unloadHandler(e))
  },
  methods: {
    beforeunloadHandler() {
      this.beforeUnload = new Date().getTime();
    },
    unloadHandler(e) {
      alert(this.beforeUnload)
      this.Handler = new Date().getTime() - this.beforeUnload;
      //判断是窗口关闭还是刷新
      if (this.Handler <= 5) {
        this.$store.commit("Idxs", '');
      }
    },
  },
  unmounted() {
    window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
    window.removeEventListener('unload', e => this.unloadHandler(e))
  },
}
